/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Address } from './Address';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
    AddressToJSONTyped,
} from './Address';
import type { BusinessType } from './BusinessType';
import {
    BusinessTypeFromJSON,
    BusinessTypeFromJSONTyped,
    BusinessTypeToJSON,
    BusinessTypeToJSONTyped,
} from './BusinessType';
import type { MerchantBrandSize } from './MerchantBrandSize';
import {
    MerchantBrandSizeFromJSON,
    MerchantBrandSizeFromJSONTyped,
    MerchantBrandSizeToJSON,
    MerchantBrandSizeToJSONTyped,
} from './MerchantBrandSize';
import type { HandoffOptions } from './HandoffOptions';
import {
    HandoffOptionsFromJSON,
    HandoffOptionsFromJSONTyped,
    HandoffOptionsToJSON,
    HandoffOptionsToJSONTyped,
} from './HandoffOptions';
import type { PhoneNumberBody } from './PhoneNumberBody';
import {
    PhoneNumberBodyFromJSON,
    PhoneNumberBodyFromJSONTyped,
    PhoneNumberBodyToJSON,
    PhoneNumberBodyToJSONTyped,
} from './PhoneNumberBody';

/**
 * 
 * @export
 * @interface UpdateBusinessAdmin
 */
export interface UpdateBusinessAdmin {
    /**
     * 
     * @type {BusinessType}
     * @memberof UpdateBusinessAdmin
     */
    type?: BusinessType;
    /**
     * 
     * @type {MerchantBrandSize}
     * @memberof UpdateBusinessAdmin
     */
    brandSize?: MerchantBrandSize;
    /**
     * 
     * @type {string}
     * @memberof UpdateBusinessAdmin
     */
    parent?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBusinessAdmin
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBusinessAdmin
     */
    internalName?: string;
    /**
     * See moment.tz.names()
     * @type {string}
     * @memberof UpdateBusinessAdmin
     */
    timeZone?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBusinessAdmin
     */
    currency?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBusinessAdmin
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBusinessAdmin
     */
    email?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateBusinessAdmin
     */
    specialInstructions?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateBusinessAdmin
     */
    prepTime?: number;
    /**
     * 
     * @type {PhoneNumberBody}
     * @memberof UpdateBusinessAdmin
     */
    phoneNumber?: PhoneNumberBody;
    /**
     * 
     * @type {Address}
     * @memberof UpdateBusinessAdmin
     */
    address: Address;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateBusinessAdmin
     */
    taxonomies?: Array<string>;
    /**
     * 
     * @type {Array<HandoffOptions>}
     * @memberof UpdateBusinessAdmin
     */
    handoffOptions?: Array<HandoffOptions>;
    /**
     * 
     * @type {string}
     * @memberof UpdateBusinessAdmin
     */
    firstDeliveryId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBusinessAdmin
     */
    merchantId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBusinessAdmin
     */
    website?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateBusinessAdmin
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateBusinessAdmin
     */
    isActive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateBusinessAdmin
     */
    isOperating?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateBusinessAdmin
     */
    distanceDeliveryMax?: number;
}



/**
 * Check if a given object implements the UpdateBusinessAdmin interface.
 */
export function instanceOfUpdateBusinessAdmin(value: object): value is UpdateBusinessAdmin {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    return true;
}

export function UpdateBusinessAdminFromJSON(json: any): UpdateBusinessAdmin {
    return UpdateBusinessAdminFromJSONTyped(json, false);
}

export function UpdateBusinessAdminFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateBusinessAdmin {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : BusinessTypeFromJSON(json['type']),
        'brandSize': json['brandSize'] == null ? undefined : MerchantBrandSizeFromJSON(json['brandSize']),
        'parent': json['parent'] == null ? undefined : json['parent'],
        'name': json['name'],
        'internalName': json['internalName'] == null ? undefined : json['internalName'],
        'timeZone': json['timeZone'] == null ? undefined : json['timeZone'],
        'currency': json['currency'] == null ? undefined : json['currency'],
        'description': json['description'] == null ? undefined : json['description'],
        'email': json['email'] == null ? undefined : json['email'],
        'specialInstructions': json['specialInstructions'] == null ? undefined : json['specialInstructions'],
        'prepTime': json['prepTime'] == null ? undefined : json['prepTime'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : PhoneNumberBodyFromJSON(json['phoneNumber']),
        'address': AddressFromJSON(json['address']),
        'taxonomies': json['taxonomies'] == null ? undefined : json['taxonomies'],
        'handoffOptions': json['handoffOptions'] == null ? undefined : ((json['handoffOptions'] as Array<any>).map(HandoffOptionsFromJSON)),
        'firstDeliveryId': json['firstDeliveryId'] == null ? undefined : json['firstDeliveryId'],
        'merchantId': json['merchantId'] == null ? undefined : json['merchantId'],
        'website': json['website'] == null ? undefined : json['website'],
        'isEnabled': json['isEnabled'] == null ? undefined : json['isEnabled'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'isOperating': json['isOperating'] == null ? undefined : json['isOperating'],
        'distanceDeliveryMax': json['distanceDeliveryMax'] == null ? undefined : json['distanceDeliveryMax'],
    };
}

export function UpdateBusinessAdminToJSON(json: any): UpdateBusinessAdmin {
    return UpdateBusinessAdminToJSONTyped(json, false);
}

export function UpdateBusinessAdminToJSONTyped(value?: UpdateBusinessAdmin | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': BusinessTypeToJSON(value['type']),
        'brandSize': MerchantBrandSizeToJSON(value['brandSize']),
        'parent': value['parent'],
        'name': value['name'],
        'internalName': value['internalName'],
        'timeZone': value['timeZone'],
        'currency': value['currency'],
        'description': value['description'],
        'email': value['email'],
        'specialInstructions': value['specialInstructions'],
        'prepTime': value['prepTime'],
        'phoneNumber': PhoneNumberBodyToJSON(value['phoneNumber']),
        'address': AddressToJSON(value['address']),
        'taxonomies': value['taxonomies'],
        'handoffOptions': value['handoffOptions'] == null ? undefined : ((value['handoffOptions'] as Array<any>).map(HandoffOptionsToJSON)),
        'firstDeliveryId': value['firstDeliveryId'],
        'merchantId': value['merchantId'],
        'website': value['website'],
        'isEnabled': value['isEnabled'],
        'isActive': value['isActive'],
        'isOperating': value['isOperating'],
        'distanceDeliveryMax': value['distanceDeliveryMax'],
    };
}

